import type { HotelAmenityData } from '@apps/main/new-desktop/core/models';
import type { GuestRatingSummary } from '@apps/main/new-desktop/modules/customersRating';
import type { HotelFilter } from '@apps/main/new-desktop/modules/hotelFilters';

import type {
  AccommodationType,
  BoardBasisCode,
  FullStars,
  IngredientType,
} from '@libs/trip-planner-interfaces';

export interface HotelSelectionFilterPillData {
  type: HotelFilter;
  text: string;
}

export interface HotelSelectionDestinationData {
  destinationText: string;
  numberOfNights?: number;
  activeFiltersAmount: number;
}

export interface HotelSelectionCardContext {
  hotelCode: string;
  ingredientIndex: number;
  selectionState: HotelSelectionCardState;
  isPreviouslySeen: boolean;
  accommodationType: AccommodationType;
}

export interface HotelSelectionCardSummaryData {
  grossPrice?: string;
  totalPrice: string;
  pax: string;
  recipeIngredientTypes: IngredientType[];
  recipeWithoutOwnTransportIngredientIndex: number;
}

export interface HotelSelectionCardData {
  imageUrls: string[];
  hotelSelectionCardContent: HotelSelectionCardContentData;
  hotelSelectionCardSummary: HotelSelectionCardSummaryData;
  context: HotelSelectionCardContext;
}

export interface HotelSelectionCardContentData {
  title: string;
  subtitle: string;
  stars: FullStars;
  content: string[];
  freeCancellation: boolean;
  amenities: HotelAmenityData[][];
  guestRating?: GuestRatingSummary;
  boardBasis?: BoardBasisCode[];
  areOtherBoardBasisOptions: boolean;
}

interface HotelSelectionListHotelCardData {
  type: HotelSelectionListDataType.HotelCard;
  data: HotelSelectionCardData[];
  id: number;
}

interface HotelSelectionListSemboBenefitsData {
  type: HotelSelectionListDataType.SemboBenefits;
  id: number;
}

export type HotelSelectionListData =
  | HotelSelectionListHotelCardData
  | HotelSelectionListSemboBenefitsData;

export const enum HotelSelectionListDataType {
  HotelCard = 'hotelCard',
  SemboBenefits = 'semboBenefits',
}

export const enum HotelSelectionViewType {
  List = 'list',
  Map = 'map',
}

export const enum HotelSelectionCardState {
  Selected = 'selected',
  Suggested = 'suggested',
  None = 'none',
}
